import { slugifySv } from "./sold-slug";

/** Kort, stabilt id-suffix så två likadana titlar aldrig krockar. */
export function vehicleIdSuffix(id: string): string {
  return id.replace(/[^a-z0-9]/gi, "").slice(-6).toLowerCase();
}

export const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * SEO-slug för fordonssidor: märke/modell + årsmodell + pris + id-suffix.
 * Exempel: /fordon/rapido-7065ff-2021-849000-a3f19c
 */
/**
 * Annonstitlarna innehåller säljfraser som inte hör hemma i en URL
 * ("Leverans i hela Sverige", "Inkommande"). De gör sluggen lång och
 * urvattnar nyckelorden, så de rensas bort innan slugifieringen.
 */
export function cleanVehicleTitle(title: string): string {
  return title
    .replace(/[,–—-]?\s*(hem)?leverans i hela sverige\.?/gi, "")
    .replace(/[,–—-]?\s*lev\.?\s*i hela sverige\.?/gi, "")
    .replace(/\s*\b(inkommande|nyinkommen|såld|reserverad)\b/gi, "")
    .replace(/\s{2,}/g, " ")
    .replace(/[\s,–—-]+$/, "")
    .trim();
}

export function vehicleSlug(v: {
  id: string;
  title: string | null;
  year?: number | null;
  price?: number | null;
}): string {
  const clean = cleanVehicleTitle(v.title ?? "") || "fordon";
  const parts: string[] = [clean];
  if (v.year && !clean.includes(String(v.year))) parts.push(String(v.year));
  if (v.price) parts.push(String(v.price));
  const base = slugifySv(parts.join(" ")) || "fordon";
  return `${base}-${vehicleIdSuffix(v.id)}`;
}
